import React from 'react';
import { Textarea } from '@Sage/hoi-poi-ui';
import { useWeb5Context } from 'lib/Web5Context';

function TextArea({ placeholder, ...props }) {
    const { t } = useWeb5Context();
    return (
        <Textarea
            labelMode="horizontal"
            placeholder={placeholder || t('cfm_placeholder_type_value')}
            {...props}
        />
    );
}

export default TextArea;
